import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatListModule } from '@angular/material/list';
import { NgxGalleryModule } from 'ngx-gallery-9';

import { LayoutRoutingModule } from './layout-routing.module';
import { LayoutComponent } from './layout.component';
import { AboutComponent } from './about/about.component';
import { ExperienceComponent } from './experience/experience.component';
import { ProjectsComponent } from './projects/projects.component';
import { SkillsComponent } from './skills/skills.component';
import { EducationComponent } from './education/education.component';
import { ContactComponent } from './contact/contact.component';
import { GalleryComponent } from './gallery/gallery.component';
import { ExpCalcPipe } from '../pipes/experience.calculator.pipe'

@NgModule({
  declarations: [LayoutComponent, AboutComponent, ExperienceComponent, ProjectsComponent, SkillsComponent, EducationComponent, ContactComponent, GalleryComponent, ExpCalcPipe],
  imports: [
    CommonModule,
    LayoutRoutingModule,
    MatToolbarModule,
    MatSidenavModule,
    MatListModule,
    NgxGalleryModule
  ]
})
export class LayoutModule { }
